<script>
  export let exitSet;
  export let updateConfig;
  export let questionSetData;
  
  // Calculate max position based on questions and nests
  $: maxPosition = calculateMaxPosition(questionSetData);
  
  function calculateMaxPosition(data) {
    if (!data || !data.questions) return 0;
    
    // Count regular questions and nested groups
    let questionCount = 0;
    let nestGroups = new Set();
    
    data.questions.forEach(question => {
      questionCount++;
      if (question.nested) {
        nestGroups.add(question.nested);
      }
    });
    
    // If there are nested groups, max position is number of nest groups
    // Otherwise, it's the number of questions
    return nestGroups.size > 0 ? nestGroups.size : questionCount;
  }
  
  function updateExitSet(value) {
    const numValue = parseInt(value);
    if (isNaN(numValue) || numValue < 0) {
      updateConfig('exitSet', undefined);
    } else {
      updateConfig('exitSet', numValue);
    }
  }
  
  function removeExitSet() {
    updateConfig('exitSet', undefined);
  }
</script>

<div class="exit-set-editor">
  <h4>Exit Set</h4>
  
  <div class="form-styled">
    {#if exitSet !== undefined}
      <div class="field-wrapper">
        <label>Exit Position (0 to {maxPosition})</label>
        <div class="input-group">
          <input 
            type="number"
            min="0"
            max={maxPosition}
            value={exitSet}
            on:input={(e) => updateExitSet(e.target.value)}
          />
          <button class="btn btn-danger btn-small" on:click={removeExitSet}>
            Remove
          </button>
        </div>
        <p class="help-text">
          Position {exitSet} of {maxPosition} total positions
          {#if maxPosition === 0}
            (No questions to skip)
          {/if}
        </p>
      </div>
    {:else}
      <p class="no-exit-set">No exit set configured</p>
      <button class="btn btn-secondary" on:click={() => updateExitSet('0')}>
        Add Exit Set
      </button>
    {/if}
  </div>
</div>

<style lang="scss">
  .exit-set-editor {
    margin-bottom: 15px;
    
    h4 {
      margin-bottom: 10px;
      font-size: 0.85rem;
      font-weight: bold;
    }
  }
  
  .field-wrapper {
    label {
      display: inline-flex;
      font-weight: bold;
      margin-bottom: 5px;
      font-size: 0.75rem;
    }
    
    .input-group {
      display: flex;
      gap: 8px;
      align-items: center;
      
      input {
        flex: 1;
        padding: 8px;
        border: 1px solid #d4d3bc;
        border-radius: 4px;
        background: white;
      }
    }
    
    .help-text {
      font-size: 0.7rem;
      color: #6b7280;
      margin-top: 5px;
      font-style: italic;
    }
  }
  
  .no-exit-set {
    font-size: 0.75rem;
    color: #6b7280;
    margin-bottom: 10px;
    font-style: italic;
  }
  
  .btn {
    padding: 6px 12px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 0.75rem;
    font-weight: bold;
    
    &.btn-small {
      padding: 4px 8px;
      font-size: 12px;
    }
    
    &.btn-secondary {
      background: #10b981;
      color: white;
      
      &:hover {
        background: #059669;
      }
    }
    
    &.btn-danger {
      background: #ef4444;
      color: white;
      
      &:hover {
        background: #dc2626;
      }
    }
  }
</style>